import axios from 'axios';

let api = process.env.VUE_APP_API;

export default () => {
    return axios.create({
        baseURL: api
        
    })
}